import { Component, OnInit } from '@angular/core';
import {SharedResources} from "../../../shared-resources";
import {FormControl, FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {APIHelper} from "../../../apihelper";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  passwordForm = new FormGroup(
    {
      OldPassword: new FormControl(''),
      NewPassword: new FormControl(''),
      RepeatNewPassword: new FormControl('')
    }
  )

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  changePassword(passwordChangeForm: any) {
    SharedResources._isLoadingBS.next(true);
    if (passwordChangeForm.value.NewPassword.length < 8) {
      alert('Parola nouă trebuie să conțină cel puțin 8 caractere!');
      SharedResources._isLoadingBS.next(false);
      return;
    }
    if (passwordChangeForm.value.NewPassword.localeCompare(passwordChangeForm.value.RepeatNewPassword) == 0) {
      alert('Repetarea parolei noi este eronată!');
      SharedResources._isLoadingBS.next(false);
      return;
    }

    this.http.post<any>(`${APIHelper.APIUrl}changepassword`,
      passwordChangeForm.value,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        alert("Parolă schimbată cu succes!");
        SharedResources._isLoadingBS.next(false);
        SharedResources.currentScreen = 'orders';
        SharedResources._currentScreenBS.next('orders');
      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }

  cancelChangePassword() {
    SharedResources.currentScreen = 'orders';
    SharedResources._currentScreenBS.next('orders');
  }
}
